import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Header from '@templates/Header/Header.js';

gsap.registerPlugin(ScrollTrigger);

const HeaderMenu = {

	init() {
		// choose_your_type: module, template, component, block, element, ... whatever
		this.el = $('header.menu');
		if (!this.el.length) return;

		this.subMenu = this.el.find('.submenu nav');
		this.onLoad();
		this.productMenu = this.el.find('.product-menu');
		if(!this.productMenu.length) return;

		const sections =$('[page="dental-set"][component="Slider"]');
		sections.each((i, el) => {
			this.bindScroll($(el));
		});
		this.bind();
	},

	onLoad() {
		const url = window.location.pathname;
		const item = this.subMenu.find('a[href="' + url + '"]');
		if(!item.length) return;
		setTimeout(() => {this.scrollToCenter(item, this.subMenu)}, 500)

	},

	bind() {
		this.productMenu.find('a').click((evt) => {
			const el = $(evt.currentTarget);
			this.scrollToCenter(el, this.productMenu);
		});
	},

	bindScroll(el) {
		const top = (Header.el.is('.hidden') ? 0 : Header.el.outerHeight()) + this.el.outerHeight();
		ScrollTrigger.create({
			trigger: el,
			start: 'top ' + top,
			end: 'bottom bottom',
			scrub: true,
			// markers: true,
			onEnter: (evt) => {
				this.onScroll(el);
			},
			onEnterBack: (evt) => {
				this.onScroll(el);
			},
		});
	},

	onScroll(el) {
		const item = this.productMenu.find('a[href="#' + el.attr('id') + '"]');
		item.addClass('selected').siblings().removeClass('selected');
		this.scrollToCenter(item, this.productMenu);
	},

	scrollToCenter(item, scroller) {
		const x = item.position().left + (item.width() / 2) - (scroller.outerWidth() / 2);
		gsap.to(scroller, { scrollTo: { x: x }, duration: 0.5, ease: 'power2.out' });
	},

	resize() {
		this.el && this.bind();
	},

};

export default HeaderMenu;